import { queryClient } from '@/infra/http'
import { userContentDetailsService } from '@/data/services/content/user-content-details-service'
import { userEnrollmentContentInfoService } from '@/data/services/content/user-enrollment-content-info-service'

/**
 * Loads content details and enrollment info for a specific content
 */
export async function loadContentDetails(contentId: number) {
  const [userContentDetails, userEnrollmentContentInfo] = await Promise.all([
    queryClient.fetchQuery({
      queryKey: ['user-content-details', contentId],
      queryFn: () => userContentDetailsService.fetchUserContentDetails(contentId),
      staleTime: 1000
    }),
    queryClient.fetchQuery({
      queryKey: ['user-enrollment-content-info', contentId],
      queryFn: () => userEnrollmentContentInfoService.fetchUserEnrollmentContentInfo(contentId),
      staleTime: 1000
    })
  ])

  return {
    userContentDetails,
    userEnrollmentContentInfo
  }
}
